import React from 'react'

function Branding() {
  return (
  <section className="bg-gray-100">
    <div className="max-w-screen-xl	mx-auto text-center">
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-start justify-between py-10 px-0">
        <div className="w-full flex flex-col justify-center items-center">
          <div className="content px-20">
            <p className="text-left font-bold text-2xl">
              Branding
            </p>
            <p className="text-left text-lg text-gray-600">
              As part of my freelance work for the agency, they also get me to do the branding logo of the product. The client's instruction is to use the colors and inspired to the Upwork logo. The client wants a simple and straightforward logo with the product name. So, I decided to combine the initials of CaseEvict, to represent its letters by itself.
            </p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-around items-center">
          <img src={require('../../common/images/caseevict/cshape.svg')} alt="C Shape Art"/>
          <div className="text-left">
            <p className="font-bold">C shape</p>
            <p className="text-sm text-gray-500">Represents <em>"case"</em></p>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-center items-center">
          <div className="pr-5">
            <p className="text-blue-600 text-xl font-bold">+</p>
          </div>
        </div>
        <div className="lg:w-1/3 md:w-4/12 sm:w-full flex flex-row justify-around items-center">
          <img src={require('../../common/images/caseevict/eshape.svg')} alt="E Shape Art" />
          <div className="text-left">
            <p className="font-bold">E shape</p>
            <p className="text-sm text-gray-500">Represents <em>"evict"</em></p>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/4 md:w-3/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/ex1.svg')} alt="Example 1 Art"/>
          </div>
        </div>
        <div className="lg:w-1/4 md:w-3/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/ex2.svg')} alt="Example 2 Art"/>
          </div>
        </div>
        <div className="lg:w-1/4 md:w-3/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/ex3.svg')} alt="Example 3 Art"/>
          </div>
        </div>
        <div className="lg:w-1/4 md:w-3/12 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/ex4.svg')} alt="Example 4 Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/font-1.svg')} alt="Font Art"/>
          </div>
        </div>
          <div className="lg:w-1/2 md:w-1/2 sm:w-full flex flex-row justify-center items-center">
          <div className="px-5">
            <img src={require('../../common/images/caseevict/font-2.svg')} alt="Font Art"/>
          </div>
        </div>
      </div>
      <div className="container mx-auto flex flex-wrap flex-col md:flex-row items-center justify-between py-10 px-0">
        <div className="w-full flex flex-row justify-center items-center">
          <img src={require('../../common/images/caseevict/color-scheme.svg')} alt="Color Scheme Art"/>
        </div>
      </div>
    </div>
  </section>
  )
}

export default Branding
